import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "row", "checkbox", "priority", "preference", "controls", "selectedCount", "search", "empty"]

  connect() {
    this.reorderRows()
    this.refresh()
  }

  toggle() {
    this.reorderRows()
    this.refresh()
  }

  moveUp(event) {
    const row = event.currentTarget.closest("[data-service-area-vehicles-target~='row']")
    const selectedRows = this.selectedRows()
    const index = selectedRows.indexOf(row)
    if (index <= 0) return

    this.listTarget.insertBefore(row, selectedRows[index - 1])
    this.refresh()
  }

  moveDown(event) {
    const row = event.currentTarget.closest("[data-service-area-vehicles-target~='row']")
    const selectedRows = this.selectedRows()
    const index = selectedRows.indexOf(row)
    if (index < 0 || index >= selectedRows.length - 1) return

    this.listTarget.insertBefore(selectedRows[index + 1], row)
    this.refresh()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLocaleLowerCase("pt-BR")
    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const visible = !query || (row.dataset.searchText || "").includes(query)
      row.classList.toggle("d-none", !visible)
      if (visible) visibleCount += 1
    })

    this.emptyTarget.classList.toggle("d-none", visibleCount > 0)
  }

  reorderRows() {
    const rows = [...this.rowTargets]
    const selected = rows
      .filter((row) => this.checkboxFor(row).checked)
      .sort((first, second) => Number(this.priorityFor(first).value) - Number(this.priorityFor(second).value))
    const available = rows
      .filter((row) => !this.checkboxFor(row).checked)
      .sort((first, second) => Number(first.dataset.originalIndex) - Number(second.dataset.originalIndex))

    const orderedRows = [...selected, ...available]
    orderedRows.forEach((row) => this.listTarget.appendChild(row))
  }

  refresh() {
    const selectedRows = this.selectedRows()

    this.rowTargets.forEach((row) => {
      const selectedIndex = selectedRows.indexOf(row)
      const selected = selectedIndex >= 0
      const preference = row.querySelector("[data-service-area-vehicles-target~='preference']")
      const controls = row.querySelector("[data-service-area-vehicles-target~='controls']")
      const priority = this.priorityFor(row)

      row.classList.toggle("bg-primary-subtle", selected)
      preference.classList.toggle("d-none", !selected)
      controls.classList.toggle("d-none", !selected)
      priority.value = selected ? selectedIndex + 1 : 100

      if (selected) preference.textContent = `${selectedIndex + 1}ª preferência`

      const buttons = controls.querySelectorAll("button")
      if (buttons[0]) buttons[0].disabled = !selected || selectedIndex === 0
      if (buttons[1]) buttons[1].disabled = !selected || selectedIndex === selectedRows.length - 1
    })

    const count = selectedRows.length
    this.selectedCountTarget.textContent = `${count} ${count === 1 ? "selecionado" : "selecionados"}`
    this.filter()
  }

  selectedRows() {
    return this.rowTargets.filter((row) => this.checkboxFor(row).checked)
  }

  checkboxFor(row) {
    return row.querySelector("[data-service-area-vehicles-target~='checkbox']")
  }

  priorityFor(row) {
    return row.querySelector("[data-service-area-vehicles-target~='priority']")
  }
}
